import { darken, saturate } from "polished";
import { color } from "./color";
const getHoverColor = (value) => darken(0.075, saturate(0.2, value));
/** @deprecated Use hover color tokens */
export const hoverColor = (prop, options) => (props) => getHoverColor(color(prop, options)(props));
